import React from 'react';
import '../css/AppleDesign.css';

const CGU = () => {
    return (
        <div style={{ background: '#F5F5F7', minHeight: '100vh', padding: '60px 20px' }}>
            <div className="container" style={{ maxWidth: '800px', margin: '0 auto' }}>
                <div className="card">
                    <h1 style={{ marginBottom: '30px', borderBottom: '1px solid #E5E5E5', paddingBottom: '20px' }}>Conditions Générales d'Utilisation</h1>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>1. Objet</h2>
                        <p className="text-secondary">
                            Les présentes Conditions Générales d'Utilisation (CGU) ont pour objet de définir les modalités et conditions d'accès et d'utilisation du site <strong>OpenGlow Beauty</strong> (ci-après « la Plateforme »), ainsi que les droits et obligations des utilisateurs.
                        </p>
                        <p className="text-secondary">
                            En accédant à la Plateforme, vous acceptez sans réserve les présentes CGU. Si vous n'acceptez pas ces conditions, vous devez cesser d'utiliser la Plateforme.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>2. Accès à la Plateforme</h2>
                        <p className="text-secondary">
                            L'accès à la Plateforme est ouvert à toute personne physique majeure (18 ans ou plus). La création d'un compte est nécessaire pour accéder aux fonctionnalités de réservation et de gestion.
                        </p>
                        <p className="text-secondary">
                            OpenGlow Beauty se réserve le droit de suspendre ou de supprimer l'accès à la Plateforme en cas de non-respect des présentes CGU, sans préavis ni indemnité.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>3. Création de Compte</h2>
                        <p className="text-secondary">
                            Lors de l'inscription, l'utilisateur s'engage à fournir des informations exactes, complètes et à jour. Il est seul responsable de la confidentialité de ses identifiants de connexion.
                        </p>
                        <p className="text-secondary">
                            Tout accès frauduleux ou utilisation non autorisée du compte doit être signalé immédiatement à l'adresse : <strong>Pedrogomescamara.pro@gmail.com</strong>.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>4. Utilisation de la Plateforme</h2>
                        <p className="text-secondary">
                            L'utilisateur s'engage à utiliser la Plateforme de manière loyale, conformément aux lois et règlements en vigueur, et dans le respect des droits des tiers. Il est notamment interdit de :
                        </p>
                        <ul style={{ color: 'rgba(60, 60, 67, 0.6)', fontSize: '14px', lineHeight: '1.8', paddingLeft: '20px' }}>
                            <li>Publier des contenus illicites, trompeurs ou offensants ;</li>
                            <li>Tenter de contourner les mesures de sécurité de la Plateforme ;</li>
                            <li>Utiliser la Plateforme à des fins commerciales non autorisées ;</li>
                            <li>Usurper l'identité d'un autre utilisateur ou d'un tiers.</li>
                        </ul>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>5. Contenu Utilisateur</h2>
                        <p className="text-secondary">
                            Les utilisateurs restent propriétaires des contenus (photos, avis, descriptions) qu'ils publient sur la Plateforme. En les publiant, ils accordent à OpenGlow Beauty une licence non exclusive d'affichage et de diffusion dans le cadre du fonctionnement du service.
                        </p>
                        <p className="text-secondary">
                            OpenGlow Beauty se réserve le droit de supprimer tout contenu ne respectant pas les présentes CGU ou la législation applicable.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>6. Responsabilités</h2>
                        <p className="text-secondary">
                            OpenGlow Beauty agit en qualité d'intermédiaire technique entre les clients et les professionnels de la beauté. Elle ne peut être tenue responsable des prestations fournies par les professionnels référencés, ni des litiges survenant entre utilisateurs.
                        </p>
                        <p className="text-secondary">
                            La Plateforme est fournie « en l'état ». OpenGlow Beauty s'efforce d'assurer sa disponibilité mais ne garantit pas un accès ininterrompu.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>7. Données Personnelles</h2>
                        <p className="text-secondary">
                            Le traitement des données personnelles est régi par la <strong>Politique de Confidentialité</strong> disponible sur la Plateforme, conformément au Règlement Général sur la Protection des Données (RGPD).
                        </p>
                        <p className="text-secondary">
                            Les utilisateurs disposent de droits d'accès, de rectification, de suppression et de portabilité de leurs données, exerçables à l'adresse : <strong>Pedrogomescamara.pro@gmail.com</strong>.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>8. Propriété Intellectuelle</h2>
                        <p className="text-secondary">
                            L'ensemble des éléments de la Plateforme (code source, design, logo, textes) est protégé par les droits de propriété intellectuelle et appartient à OpenGlow Beauty ou à ses licenciés. Toute reproduction ou utilisation sans autorisation est strictement interdite.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>9. Modification des CGU</h2>
                        <p className="text-secondary">
                            OpenGlow Beauty se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés des modifications significatives par e-mail ou via une notification sur la Plateforme. La poursuite de l'utilisation après notification vaut acceptation des nouvelles CGU.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>10. Droit Applicable et Litiges</h2>
                        <p className="text-secondary">
                            Les présentes CGU sont soumises au droit français. En cas de litige, une solution amiable sera recherchée en priorité. À défaut, les tribunaux compétents du ressort du siège social d'OpenGlow Beauty seront saisis.
                        </p>
                    </section>

                    <p className="text-secondary" style={{ fontSize: '12px', marginTop: '40px', borderTop: '1px solid #E5E5E5', paddingTop: '20px' }}>
                        Dernière mise à jour : mai 2026
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CGU;
